<template>
<div class="comFooter">
    <div class="pw fontSong12">
        <i class="arial">Copyright Reserved 2000-2022 </i>
        雅昌艺术网 版权所有
        <span>|</span>
        商标版权及免责声明
        <a href="http://www.artron.net/" target="_blank" class="art">访问雅昌艺术网</a>
        <br>
        经营许可证：粤<i class="arial">B2-20030053</i>
    </div>
</div>
</template>

<script>
export default {
    name: "comFooter",
    props:['comName'],
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.comFooter{
    border-top: 1px solid #000;
    color: #666;
    margin-top: 100px;
    line-height: 22px;
    padding: 3px 0 36px 0;
    span{
        color: #ccc;
        padding: 0px 10px;
    }
    .art{
        text-decoration: underline;
        color: #666;
        margin-left: 30px;
    }
}
</style>